export default __webpack_public_path__ + "static/media/grainBuds_02.65e7248b.png";